export const BRAND = {
  name: "Velor Advisory",
  tagline: "British Expertise. Dubai Excellence.",
  email: "contact@velor.ae",
  whatsapp: "+971585094170",
  whatsappDigits: "971585094170",
  whatsappUrl: "https://wa.me/message/XILZHT7VX372D1",
  calendly: "https://calendly.com/contact-velor/30min",
  addressShort: "Dubai, United Arab Emirates",
  logoBlack: "https://customer-assets.emergentagent.com/job_golden-visa-luxury/artifacts/ernd4p6o_Velor%20logo%20black.png",
  logoWhite: "https://customer-assets.emergentagent.com/job_golden-visa-luxury/artifacts/gtm3vhx0_Velor%20logo%20white.png",
};

export const SERVICES = [
  { slug: "golden-visa", title: "Golden Visa", short: "10-year UAE residency for investors, entrepreneurs and skilled professionals." },
  { slug: "residency-visa", title: "Residency Visas", short: "Employment, investor and family residency permits handled end-to-end." },
  { slug: "business-setup", title: "Business Setup", short: "Mainland & Free Zone company formation across the UAE." },
  { slug: "company-formation", title: "Company Formation", short: "From company registration and licensing to banking and operational setup." },
  { slug: "relocation", title: "Relocation Planning", short: "Schools, housing, banking and lifestyle—curated for your move." },
  { slug: "family-visa", title: "Family Visas", short: "Sponsor your spouse, children and parents with full support." },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/golden-visa", label: "Golden Visa" },
  { to: "/business-setup", label: "Business Setup" },
  { to: "/relocation", label: "Relocation" },
  { to: "/insights", label: "Insights" },
  { to: "/contact", label: "Contact" },
];
